export const common = {
  nav: {
    top: 'Top',
    profile: 'Profile',
    contact: 'Contact',
    onlineShop: 'Online Shop',
    onlineStore: 'Online store',
    wechat: 'WeChat'
  },
  hero: {
    title1: '',
    title2: '北海道産',
    title3: '乾燥なまこ',
    factoryTitle: '小樽工場'
  },
  intro: {
    title1: '〜北海道 小樽から最高品質のなまこを〜',
    title2: '天然の恵みを日本の技術で丁寧に加工し、世界の食卓へ',
    desc3: '北海道の冷たい海で育つなまこは',
    desc4: '栄養価が非常に高く',
    desc5: '古くから滋養強壮や美容食材として',
    desc6: '重宝されてきました',
    desc7: 'その中でも当店が取り扱うなまこは',
    desc8: '最高級品の天然ものの【キンコ】',
    desc9: '自社工場で丁寧に加工、乾燥し',
    desc10: 'その品質をお約束します'
  },
  shop: {
    title: 'Online Shop',
    comingSoon: 'Coming soon..',
    button: 'Move'
  },
  faq: {
    title: 'FAQ',
    subtitle: 'よくあるご質問',
    q1: '北海道のどこで獲れたなまこですか?',
    a1: '北海道全域にて通年仕入れをしておりますので、時期によって産地は異なります。',
    q2: '海外発送は対応していますか?',
    a2: '対応しております。発送方法によって金額が異なりますので詳しくはお問い合わせください。',
    q3: '北海道のなまこはなぜ高価なのですか?',
    a3: '北海道のなまこは他の地域のものと比べ栄養価が高いです。またイボが大きく美しいことから【黒いダイヤ】とも呼ばれています。',
    q4: '原産地証明、放射能検査証明書はありますか?',
    a4: 'ございますが、通関用書類ですので業者様のみにお渡ししております。'
  },
  preparation: {
    title: 'なまこの戻し方',
    step1Title: 'Step 1',
    step1Desc1: 'なまこの表面の汚れを軽く洗い、24~36時間浸水させる。',
    step1Desc2: '1日1回はお水を交換します。',
    step2Title: 'Step 2',
    step2Desc: '柔らかくなったら、お腹の部分の切り目から包丁を入れ内臓の残りや砂を綺麗に取り除きます。',
    step3Title: 'Step 3',
    step3Desc: '綺麗になったなまこを、好みの柔らかさになるまで茹でる。1時間ほど煮ると程よくなります。',
    step4Title: 'Step 4',
    step4Desc: '火を止めたら自然にそのまま粗熱が冷めるのを待ち氷を加えて冷蔵庫で48~72時間冷やします。'
  },
  knowledge: {
    title: 'なまこ豆知識',
    heading1: '滋養強壮に良いといわれるなまこ。',
    heading2: '一体何がカラダに良いのでしょう?',
    desc1: '北海道産【黒なまこ】は主成分が',
    desc2: 'コラーゲンでできていて',
    desc3: 'アミノ酸がとても豊富です。',
    desc4: '造血作用、カルシウムの吸収促進、性機能や体力増強に役立つとされ他にも疲労回復、冷え性改善、乾燥肌対策など嬉しい効能盛り沢山!',
    desc5: 'なまこは海の【朝鮮人参】とも呼ばれその栄養価と強壮作用から',
    desc6: '古くから重宝されてきました。',
    desc7: '実際に貧血気味の妊婦さんが弊社のなまこを食べ続けて数値が劇的に改善したり、膝の悪かったおばあちゃんの具合が良くなったなど嬉しい声が多数届いております!'
  },
  news: {
    title: 'News',
    date1: '2025/8/1',
    content1: 'HPをリニューアルしました。'
  },
  footer: {
    copyright: 'Copyright 2025 Miyakoya'
  },
  wechat: {
    mainTitle: 'WeChatはこちら'
  },
  profile: {
    title: 'プロフィール',
    companyName: '会社名',
    companyNameValue: '都や',
    established: '設立',
    establishedValue: '2015年4月1日',
    capital: '資本金',
    capitalValue: '500万円',
    ceo: '代表取締役',
    ceoValue: '武田敏之',
    address: '本社所在地',
    addressValue1: '〒335-0025',
    addressValue2: '埼玉県戸田市南町3−27',
    branch: '拠点',
    branchValue: '北海道 小樽工場',
    employees: '従業員数',
    employeesValue: '10名(2025年8月現在)',
    business: '事業内容',
    businessValue: '●水産物の仕入れ・加工販売・海外輸出',
    banks: '取引銀行',
    banksValue1: '●三菱UFJ銀行渋谷支店',
    banksValue2: '●小樽信用金庫',
    history: '会社沿革',
    history1Title: '●2015年4月',
    history1Value: '株式会社リーダーズを資本金500万円で設立',
    history2Title: '●2020年',
    history2Value: '資本金を2000万に増資',
    history3Title: '●2020年',
    history3Value: '北海道 小樽工場にて加工開始'
  },
  contact: {
    title: 'お問い合わせ',
    lastName: '姓',
    firstName: '名',
    companyName: '会社名',
    post: '部署・役職',
    phone: '電話番号',
    email: 'アドレス',
    inquiry: 'お問い合わせ内容',
    required: '必須',
    phonePlaceholder: '080-0000-0000',
    emailPlaceholder: 'xxxx@example.com',
    inquiryPlaceholder: 'お問い合わせ内容',
    charCount: '文字',
    notRobot: '私はロボットではありません',
    submit: '送信',
    submitting: '送信中...',
    successMessage: '送信が完了しました。ありがとうございます。',
    errorMessage: '送信に失敗しました。もう一度お試しください。',
    privacyNote: '利用規約・プライバシーポリシーをお読みの上、同意して送信して下さい。',
    robotAlert: 'ロボットではないことを確認してください。',
    requiredAlert: '必須項目を入力してください。',
    charLimitAlert: 'お問い合わせ内容は500文字以内で入力してください。'
  }
};
